import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/it/pancam.jpg'
import _imports_1 from './1.jpg'
import _imports_2 from './2.jpg'
import _imports_3 from './3.jpg'


const _hoisted_1 = { class: "pancam" }
const _hoisted_2 = { class: "pancam_container" }
const _hoisted_3 = { class: "pancam_inner" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"全景相机\"><h3>全景监测站</h3><p class=\"pancam_two\">720°全景监测基站集成摄像头、光感传感器、空气温湿度传感器，实现720°高清图像、负氧离子、环境温度、湿地、大气压和光照强度等数据的实时采集和远程监控。</p><h3>软件</h3><div class=\"pancam_imgList\"><img src=\"" + _imports_1 + "\"><img src=\"" + _imports_2 + "\"><img src=\"" + _imports_3 + "\" alt=\"\"></div>", 5)

import DeviceNav from '@/components/DeviceNav.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  activeIndex: Number
},
  emits: ["heightChange", "wheelChange", 'indexChange'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DeviceNav),
        _hoisted_4
      ])
    ])
  ]))
}
}

})